import type { TGetEmpreendimentoMidiaResponse } from '@/features/empreendimentos/shared/types/empreendimento'
import { HttpService } from '@/infra/http'

export class GetEmpreendimentoPlantasService extends HttpService {
  execute = async (idExterno: number) => {
    return this.http.get<TGetEmpreendimentoMidiaResponse>(`api/v2/Empreendimento/${idExterno}/plantas`)
  }
}
